import { createFileRoute } from '@tanstack/react-router';

import { OwnerPayrollPage } from '@/features/payroll/OwnerPayrollPage';

export const Route = createFileRoute('/_authed/owner/payroll')({
  component: OwnerPayrollPage,
});
